import { AlertTriangle } from "lucide-react";
import { usePublicSettings } from "@/lib/settings";

const DEFAULT_MESSAGE =
  "Our pickup & drop-off service is temporarily unavailable while our vehicle is being repaired. All in-workshop services are running as normal — thanks for your patience!";

/**
 * Shows a prominent yellow notice when the owner has paused logistics
 * from Admin → Settings. Renders nothing when the service is available.
 * Reads live from the public-settings cache so flipping the admin toggle
 * updates every page on the next refresh.
 */
export default function LogisticsPausedBanner() {
  const settings = usePublicSettings();
  if (settings?.logistics_available !== false) return null;
  const message = (settings?.logistics_unavailable_message || "").trim() || DEFAULT_MESSAGE;

  return (
    <div
      role="alert"
      className="w-full bg-spark-yellow border-y-2 border-spark-yellow-dark/40 text-spark-ink"
      data-testid="logistics-paused-banner"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 pl-28 sm:pl-32 lg:pl-40 flex items-start gap-3">
        <div className="shrink-0 mt-0.5">
          <AlertTriangle className="size-5" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display uppercase tracking-wider text-xs font-bold leading-tight mb-0.5">
            Pickup &amp; Drop-off paused
          </p>
          <p className="text-sm leading-snug">{message}</p>
        </div>
      </div>
    </div>
  );
}
